/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_Searchbuilds1Inputs */

const id_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const ms_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const da_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const de_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const en_us2_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const es_es2_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar versiones o fechas…`)
};

const es_mx2_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca versiones o fechas…`)
};

const fil_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const fr_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const it_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const hu_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const nl_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const no_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const pl_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const pt_br2_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const pt_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const ro_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const fi_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const sv_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const vi_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const tr_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const cs_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const bg_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const ru_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по версиям или датам…`)
};

const uk_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const ar_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const hi_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ज़न या तारीखें खोजें…`)
};

const th_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเวอร์ชันหรือวันที่…`)
};

const ja_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const zh_cn2_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

const zh_hant1_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋版本或日期…`)
};

const ko_builds_timeline_searchbuilds1 = /** @type {(inputs: Builds_Timeline_Searchbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions or dates…`)
};

/**
* | output |
* | --- |
* | "Search versions or dates…" |
*
* @param {Builds_Timeline_Searchbuilds1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_searchbuilds1 = /** @type {((inputs?: Builds_Timeline_Searchbuilds1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_Searchbuilds1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_searchbuilds1(inputs)
	if (locale === "ms") return ms_builds_timeline_searchbuilds1(inputs)
	if (locale === "da") return da_builds_timeline_searchbuilds1(inputs)
	if (locale === "de") return de_builds_timeline_searchbuilds1(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_searchbuilds1(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_searchbuilds1(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_searchbuilds1(inputs)
	if (locale === "fil") return fil_builds_timeline_searchbuilds1(inputs)
	if (locale === "fr") return fr_builds_timeline_searchbuilds1(inputs)
	if (locale === "it") return it_builds_timeline_searchbuilds1(inputs)
	if (locale === "hu") return hu_builds_timeline_searchbuilds1(inputs)
	if (locale === "nl") return nl_builds_timeline_searchbuilds1(inputs)
	if (locale === "no") return no_builds_timeline_searchbuilds1(inputs)
	if (locale === "pl") return pl_builds_timeline_searchbuilds1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_searchbuilds1(inputs)
	if (locale === "pt") return pt_builds_timeline_searchbuilds1(inputs)
	if (locale === "ro") return ro_builds_timeline_searchbuilds1(inputs)
	if (locale === "fi") return fi_builds_timeline_searchbuilds1(inputs)
	if (locale === "sv") return sv_builds_timeline_searchbuilds1(inputs)
	if (locale === "vi") return vi_builds_timeline_searchbuilds1(inputs)
	if (locale === "tr") return tr_builds_timeline_searchbuilds1(inputs)
	if (locale === "cs") return cs_builds_timeline_searchbuilds1(inputs)
	if (locale === "bg") return bg_builds_timeline_searchbuilds1(inputs)
	if (locale === "ru") return ru_builds_timeline_searchbuilds1(inputs)
	if (locale === "uk") return uk_builds_timeline_searchbuilds1(inputs)
	if (locale === "ar") return ar_builds_timeline_searchbuilds1(inputs)
	if (locale === "hi") return hi_builds_timeline_searchbuilds1(inputs)
	if (locale === "th") return th_builds_timeline_searchbuilds1(inputs)
	if (locale === "ja") return ja_builds_timeline_searchbuilds1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_searchbuilds1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_searchbuilds1(inputs)
	return ko_builds_timeline_searchbuilds1(inputs)
});
export { builds_timeline_searchbuilds1 as "builds.timeline.searchBuilds" }